import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiGiphyService } from '@fi-shared/fi-giphy/fi-giphy.service';
import { FiInsertGiphyComponent } from './fi-insert-giphy/fi-insert-giphy.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { MatInputModule } from '@angular/material/input';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        FiLoadingModule,
        MatInputModule,
        FiAppTextSharedModule,
        FormsModule,
        FiWhenScrolledModule,
    ],
    providers: [FiGiphyService],
    declarations: [FiInsertGiphyComponent],
    exports: [FiInsertGiphyComponent],
})
export class FiGiphyModule {}
